import { FC, ReactNode } from 'react'
import { Col } from 'antd'
import { useTranslation } from 'react-i18next'
import PerSpacer from '../../../../components/custom_components/Spacer'
import PerFlexRow from '../../../../components/custom_components/FlexRow'
import PerText from '../../../../components/custom_components/Text'
import { PerCollapse } from '../../../../components/custom_components/Collapse'

interface ContractChangeCareerPathRowProps {
  label: string
  current: ReactNode
  change: ReactNode
  mt?: 's' | 'xl' | undefined
  isPreparation?: boolean
}

export const ContractChangeCareerPathRow: FC<ContractChangeCareerPathRowProps> = ({
  label,
  current,
  change,
  mt = 's',
  isPreparation = false,
}) => {
  const [t] = useTranslation()
  return (
    <PerSpacer mt={mt}>
      {!!isPreparation ? (
        <>
          <PerFlexRow mb="xxxs">
            <Col span={12}>
              <PerText appearance="label-small" color="secondary">
                {t(`appraisalMeeting.contract.${label}`)}
              </PerText>
            </Col>
            <Col span={12}>
              <PerText appearance="label-small" color="secondary">
                {t(`appraisalMeeting.contract.${label}`)}
              </PerText>
            </Col>
          </PerFlexRow>
          <PerFlexRow align="middle">
            <Col span={12}>
              <PerText>{current}</PerText>
            </Col>
            <Col span={12}>{change}</Col>
          </PerFlexRow>
        </>
      ) : (
        <div className="per-collapse-career-path-height">
          <PerFlexRow align="top" mb="s">
            <Col span={12}>
              <div className="per-collapse-header">
                <PerCollapse
                  panels={[
                    {
                      headingElement: (
                        <PerText appearance="label-small" color="secondary" mb="none">
                          {t(`appraisalMeeting.contract.careerPath`)}
                        </PerText>
                      ),
                      content: current,
                    },
                  ]}
                  stripMargin
                  iconSize={8}
                />
              </div>
            </Col>
            <Col span={12}>
              <div className="per-collapse-header">
                <PerCollapse
                  panels={[
                    {
                      headingElement: (
                        <PerText appearance="label-small" color="secondary" mb="none">
                          {t(`appraisalMeeting.contract.careerPath`)}
                        </PerText>
                      ),
                      content: change,
                    },
                  ]}
                  stripMargin
                  iconSize={8}
                />
              </div>
            </Col>
          </PerFlexRow>
        </div>
      )}
    </PerSpacer>
  )
}
